import { Date_normalizeDateString } from "../../../common/dateUtils";
import { RadioButtonOption, SignatureType } from "../../../common/enums";
import { formElement } from "../../forms/FormElement";
import MeasuresFormState from "../../forms/Permits/Conditions/MeasuresFormState";
import { Signature_normalize } from "../../Signature";
import { ElectricDisconnectionChecklist } from "./ElectricDisconnectionChecklist";
import { ElectricFenceChecklist } from "./ElectricFenceChecklist";
import { Take2Checklist } from "./Take2Checklist";
import { WorkOnRoadChecklist } from "./WorkOnRoadChecklist";
import { ConstructionPowerChecklist } from "./ConstructionPowerChecklist";

type Measures = {
    gasFreeDeclaration: boolean;
    processEquipmentCleanedAndPressureFree: boolean;
    demarcationMeters: number | undefined;
    demarcationMetersChecked: boolean;
    electricalDisconnection: boolean;
    electricDisconnectionChecklist: ElectricDisconnectionChecklist;
    electricFenceOnOff: boolean;
    electricFenceChecklist: ElectricFenceChecklist;
    guardsPerTeamChecked: boolean;
    guardType: string;
    numberOfGuardsPerTeam: number | undefined;
    fireGuardsPerTeamChecked: boolean;
    numberOfFireGuardsPerTeam: number | undefined;
    lineGuardWillBeInformed: boolean;
    take2: boolean;
    take2Checklist: Take2Checklist;
    workOnRoad: boolean;
    workOnRoadChecklist: WorkOnRoadChecklist;
    constructionPower: boolean;
    constructionPowerChecklist: ConstructionPowerChecklist;
    isFlangeOpeningIncludedInPrint: boolean;
    otherInformation: string;
    interventionOnProcessEquipment: boolean;
};

export default Measures;

export function Measures_normalize(measures: Measures): Measures {
const normalizedMeasures: Measures = {
    take2Checklist: {
        checklistVersion: measures.take2Checklist?.checklistVersion ?? 0,
        riskObservationDateTime: Date_normalizeDateString(measures.take2Checklist.riskObservationDateTime),
        dutySwitchIsDisconnected: measures.take2Checklist.dutySwitchIsDisconnected ?? RadioButtonOption.None,
        equipmentIsDrainedAndNoPreassure:
            measures.take2Checklist.equipmentIsDrainedAndNoPreassure ?? RadioButtonOption.None,
        hasAppropriateScaffolding: measures.take2Checklist.hasAppropriateScaffolding ?? RadioButtonOption.None,
        haveEquipment: measures.take2Checklist.haveEquipment ?? RadioButtonOption.None,
        haveProtectionEquipment: measures.take2Checklist.haveProtectionEquipment ?? RadioButtonOption.None,
        haveReadPermitAndTerms: measures.take2Checklist.haveReadPermitAndTerms ?? RadioButtonOption.None,
        haveUnderstoodInstructions: measures.take2Checklist.haveUnderstoodInstructions ?? RadioButtonOption.None,
        isNearbyWork: measures.take2Checklist.isNearbyWork ?? RadioButtonOption.None,
        needsBlockingOff: measures.take2Checklist.needsBlockingOff ?? RadioButtonOption.None,
        rightPlaceAndEquipment: measures.take2Checklist.rightPlaceAndEquipment ?? RadioButtonOption.None,
        riskObservationCauseDescription: measures.take2Checklist.riskObservationCauseDescription ?? "",
        riskObservationCourseOfEvents: measures.take2Checklist.riskObservationCourseOfEvents ?? "",
        riskObservationFixSuggestion: measures.take2Checklist.riskObservationFixSuggestion ?? "",
        riskObservationLocation: measures.take2Checklist.riskObservationLocation ?? "",
        riskObservationNotifier: measures.take2Checklist.riskObservationNotifier ?? "",
        riskOfBurnsCrushCuts: measures.take2Checklist.riskOfBurnsCrushCuts ?? RadioButtonOption.None,
        riskOfFallsOrFallingObjects: measures.take2Checklist.riskOfFallsOrFallingObjects ?? RadioButtonOption.None,
        riskOfFire: measures.take2Checklist.riskOfFire ?? RadioButtonOption.None,
        whatRTO: measures.take2Checklist.whatRTO ?? "",
        whereIsClosestAlarmEquipmentDescription:
            measures.take2Checklist.whereIsClosestAlarmEquipmentDescription ?? "",
        whereIsClosestEyeWashAndShowerDescription:
            measures.take2Checklist.whereIsClosestEyeWashAndShowerDescription ?? "",
        whichProcessEquipmentMediaDescription: measures.take2Checklist.whichProcessEquipmentMediaDescription ?? "",
        whereIsClosestExtinguishingEquipmentDescription:
            measures.take2Checklist.whereIsClosestExtinguishingEquipmentDescription ?? "",
        knowWhereClosestAlarmEquipmentIs: measures.take2Checklist.knowWhereClosestAlarmEquipmentIs ?? RadioButtonOption.None,
        haveKnowledgeOfProcessEquipmentMedia: measures.take2Checklist.haveKnowledgeOfProcessEquipmentMedia ?? RadioButtonOption.None,
        needsWorkplaceBlockingOff: measures.take2Checklist.needsWorkplaceBlockingOff ?? RadioButtonOption.None,
        knowWhereClosestEyeWashAndShowerIs: measures.take2Checklist.knowWhereClosestEyeWashAndShowerIs ?? RadioButtonOption.None,
        hasFireRisk: measures.take2Checklist.hasFireRisk ?? RadioButtonOption.None,
        knowWhereClosestExtinguishingEquipmentIs: measures.take2Checklist.knowWhereClosestExtinguishingEquipmentIs ?? RadioButtonOption.None
    },
        gasFreeDeclaration: measures.gasFreeDeclaration ?? false,
        demarcationMeters: measures.demarcationMeters,
        demarcationMetersChecked: measures.demarcationMetersChecked ?? false,
        electricalDisconnection: measures.electricalDisconnection ?? false,
        electricDisconnectionChecklist: {
            checklistVersion: measures.electricDisconnectionChecklist.checklistVersion ?? 0,
            cablesAreWithoutRiskOfFalling:
                measures.electricDisconnectionChecklist.cablesAreWithoutRiskOfFalling ?? RadioButtonOption.None,
            electricConnectionsAreAboveGround:
                measures.electricDisconnectionChecklist.electricConnectionsAreAboveGround ?? RadioButtonOption.None,
            equipmentIsConnectedToEarthFaultBreaker:
                measures.electricDisconnectionChecklist.equipmentIsConnectedToEarthFaultBreaker ??
                RadioButtonOption.None,
            powerIsCutAndFusesRemoved:
                measures.electricDisconnectionChecklist.powerIsCutAndFusesRemoved ?? RadioButtonOption.None,
            responsibleElectricianName: measures.electricDisconnectionChecklist.responsibleElectricianName ?? "",
            responsibleElectricianPhoneNumber:
                measures.electricDisconnectionChecklist.responsibleElectricianPhoneNumber ?? "",
            signIsAtElectricalBreaker:
                measures.electricDisconnectionChecklist.signIsAtElectricalBreaker ?? RadioButtonOption.None
        },
        electricFenceChecklist: {
            checklistVersion: measures.electricFenceChecklist.checklistVersion ?? 0,
            checkedPowerIsOn: measures.electricFenceChecklist.checkedPowerIsOn ?? RadioButtonOption.None,
            controlledNoPersonAtFence:
                measures.electricFenceChecklist.controlledNoPersonAtFence ?? RadioButtonOption.None,
            highVoltageIsGrounded: measures.electricFenceChecklist.highVoltageIsGrounded ?? RadioButtonOption.None,
            lowHighVoltageIsCut: measures.electricFenceChecklist.lowHighVoltageIsCut ?? RadioButtonOption.None,
            portEntryIsInformedOfWork:
                measures.electricFenceChecklist.portEntryIsInformedOfWork ?? RadioButtonOption.None,
            powerOffCounterSignatureRequest: measures.electricFenceChecklist.powerOffCounterSignatureRequest,
            powerOffDirectorFlammableProductSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOffDirectorFlammableProductSignature,
                SignatureType.PowerOffDirectorFlammableProduct),
            powerOffExternalDirectorFlammableProductSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOffExternalDirectorFlammableProductSignature,
                SignatureType.PowerOffExternalDirectorFlammableProduct
                ),
            powerOffResponsibleElectricianSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOffResponsibleElectricianSignature,
                SignatureType.PowerOffResponsibleElectrician
            ),
            powerOffWorkLeaderSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOffWorkLeaderSignature,
                SignatureType.PowerOffWorkLeader
            ),
            powerOffIsControlled: measures.electricFenceChecklist.powerOffIsControlled ?? RadioButtonOption.None,
            powerOnCounterSignatureRequest: measures.electricFenceChecklist.powerOnCounterSignatureRequest,
            powerOnDirectorFlammableProductSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOnDirectorFlammableProductSignature,
                SignatureType.PowerOnDirectorFlammableProduct
            ),
            powerOnExternalDirectorFlammableProductSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOnExternalDirectorFlammableProductSignature,
                SignatureType.PowerOnExternalDirectorFlammableProduct
            ),
            powerOnResponsibleElectricianSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOnResponsibleElectricianSignature,
                SignatureType.PowerOnResponsibleElectrician
            ),
            powerOnWorkLeaderSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOnWorkLeaderSignature,
                SignatureType.PowerOnWorkLeader
            ),
            powerOnPortOfficerSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOnPortOfficerSignature,
                SignatureType.PowerOnPortOfficer
            ),
            powerOffPortOfficerSignature: Signature_normalize(
                measures.electricFenceChecklist.powerOffPortOfficerSignature,
                SignatureType.PowerOffPortOfficer
            ),
            securityCoordinatorInformedPermitReturned:
                measures.electricFenceChecklist.securityCoordinatorInformedPermitReturned ?? RadioButtonOption.None,
            securityCoordinatorInformedPermitUpdated:
                measures.electricFenceChecklist.securityCoordinatorInformedPermitUpdated ?? RadioButtonOption.None,
            securityRoundPerformed: measures.electricFenceChecklist.securityRoundPerformed ?? RadioButtonOption.None,
            workInProgressSignIsUp: measures.electricFenceChecklist.workInProgressSignIsUp ?? RadioButtonOption.None,
            signIsAtBreakerOrFuse: measures.electricFenceChecklist.signIsAtBreakerOrFuse ?? RadioButtonOption.None,
            powerOffWillBeControlled: measures.electricFenceChecklist.powerOffWillBeControlled ?? RadioButtonOption.None,
            securityCoordinatorInformedAboutStartedWork: measures.electricFenceChecklist.securityCoordinatorInformedAboutStartedWork ?? RadioButtonOption.None,
            electricianInformedPortEntryWorkComplete: measures.electricFenceChecklist.electricianInformedPortEntryWorkComplete ?? RadioButtonOption.None,
            securityCoordinatorInformedWorkComplete: measures.electricFenceChecklist.securityCoordinatorInformedWorkComplete ?? RadioButtonOption.None
        },
        electricFenceOnOff: measures.electricFenceOnOff ?? false,
        fireGuardsPerTeamChecked: measures.fireGuardsPerTeamChecked ?? false,
        guardsPerTeamChecked: measures.guardsPerTeamChecked ?? false,
        guardType: measures.guardType ?? "",
        interventionOnProcessEquipment: measures.interventionOnProcessEquipment ?? false,
        isFlangeOpeningIncludedInPrint: measures.isFlangeOpeningIncludedInPrint ?? false,
        lineGuardWillBeInformed: measures.lineGuardWillBeInformed ?? false,
        numberOfFireGuardsPerTeam: measures.numberOfFireGuardsPerTeam,
        numberOfGuardsPerTeam: measures.numberOfGuardsPerTeam,
        otherInformation: measures.otherInformation ?? "",
        processEquipmentCleanedAndPressureFree: measures.processEquipmentCleanedAndPressureFree ?? false,
        take2: measures.take2 ?? false,
        workOnRoad: measures.workOnRoad ?? false,
        workOnRoadChecklist: {
            checklistVersion: measures.workOnRoadChecklist?.checklistVersion ?? 0,
            hasTAPlan: measures.workOnRoadChecklist?.hasTAPlan ?? RadioButtonOption.None,
            hasAtLeastTwoTrafficSignBoards: measures.workOnRoadChecklist?.hasAtLeastTwoTrafficSignBoards ?? RadioButtonOption.None,
            allWorkersHaveCorrectRoadWorkTraining: measures.workOnRoadChecklist?.allWorkersHaveCorrectRoadWorkTraining ?? RadioButtonOption.None,
            allWorkersHaveCorrectProtectiveEquipment: measures.workOnRoadChecklist?.allWorkersHaveCorrectProtectiveEquipment ?? RadioButtonOption.None,
            canUnprotectedIndividualsPassSafely: measures.workOnRoadChecklist?.canUnprotectedIndividualsPassSafely ?? RadioButtonOption.None
        },
        constructionPower: measures.constructionPower ?? false,
        constructionPowerChecklist: {
            checklistVersion: measures.constructionPowerChecklist?.checklistVersion ?? 0,
            willCableBePlacedOnBareGround: measures.constructionPowerChecklist?.willCableBePlacedOnBareGround ?? RadioButtonOption.None,
            allJunctionsInTrayOrSuspendedAboveGround: measures.constructionPowerChecklist?.allJunctionsInTrayOrSuspendedAboveGround ?? RadioButtonOption.None,
            cablesAreWithoutTripHazard: measures.constructionPowerChecklist?.cablesAreWithoutTripHazard ?? RadioButtonOption.None,
            cableIsInProtectionTube: measures.constructionPowerChecklist?.cableIsInProtectionTube ?? RadioButtonOption.None,
            cableGoesOverRoadCycleOrWalkway: measures.constructionPowerChecklist?.cableGoesOverRoadCycleOrWalkway ?? RadioButtonOption.None,
            isCableProtectedWithRunOverProtection: measures.constructionPowerChecklist?.isCableProtectedWithRunOverProtection ?? RadioButtonOption.None,
            haveSignsWarningForCableOverRoad: measures.constructionPowerChecklist?.haveSignsWarningForCableOverRoad ?? RadioButtonOption.None
        }
    };

    return normalizedMeasures;
}

export function Measures_toFormState(measures: Measures): MeasuresFormState {
    const electricalDisconnectionChecklist = measures.electricDisconnectionChecklist;
    const electricFenceChecklist = measures.electricFenceChecklist;
    const take2Checklist = measures.take2Checklist;
    const workOnRoadChecklist = measures.workOnRoadChecklist;
    const constructionPowerChecklist = measures.constructionPowerChecklist;

    return {
        demarcationMeters: formElement(measures.demarcationMeters),
        demarcationMetersChecked: formElement(measures.demarcationMetersChecked),
        electricalDisconnection: formElement(measures.electricalDisconnection),
        electricDisconnectionChecklist: {
            cablesAreWithoutRiskOfFalling: formElement(electricalDisconnectionChecklist.cablesAreWithoutRiskOfFalling),
            electricConnectionsAreAboveGround: formElement(
                electricalDisconnectionChecklist.electricConnectionsAreAboveGround
            ),
            equipmentIsConnectedToEarthFaultBreaker: formElement(
                electricalDisconnectionChecklist.equipmentIsConnectedToEarthFaultBreaker
            ),
            powerIsCutAndFusesRemoved: formElement(electricalDisconnectionChecklist.powerIsCutAndFusesRemoved),
            responsibleElectricianName: formElement(electricalDisconnectionChecklist.responsibleElectricianName),
            responsibleElectricianPhoneNumber: formElement(
                electricalDisconnectionChecklist.responsibleElectricianPhoneNumber
            ),
            signIsAtElectricalBreaker: formElement(electricalDisconnectionChecklist.signIsAtElectricalBreaker)
        },
        electricFenceChecklist: {
            checkedPowerIsOn: formElement(electricFenceChecklist.checkedPowerIsOn),
            controlledNoPersonAtFence: formElement(electricFenceChecklist.controlledNoPersonAtFence),
            highVoltageIsGrounded: formElement(electricFenceChecklist.highVoltageIsGrounded),
            lowHighVoltageIsCut: formElement(electricFenceChecklist.lowHighVoltageIsCut),
            portEntryIsInformedOfWork: formElement(electricFenceChecklist.portEntryIsInformedOfWork),
            powerOffIsControlled: formElement(electricFenceChecklist.powerOffIsControlled),
            securityCoordinatorInformedPermitReturned: formElement(
                electricFenceChecklist.securityCoordinatorInformedPermitReturned
            ),
            securityCoordinatorInformedPermitUpdated: formElement(
                electricFenceChecklist.securityCoordinatorInformedPermitUpdated
            ),
            securityRoundPerformed: formElement(electricFenceChecklist.securityRoundPerformed),
            workInProgressSignIsUp: formElement(electricFenceChecklist.workInProgressSignIsUp),
            signIsAtBreakerOrFuse: formElement(electricFenceChecklist.signIsAtBreakerOrFuse),
            powerOffWillBeControlled: formElement(electricFenceChecklist.powerOffWillBeControlled),
            securityCoordinatorInformedAboutStartedWork: formElement(electricFenceChecklist.securityCoordinatorInformedAboutStartedWork),
            electricianInformedPortEntryWorkComplete: formElement(electricFenceChecklist.electricianInformedPortEntryWorkComplete),
            securityCoordinatorInformedWorkComplete: formElement(electricFenceChecklist.securityCoordinatorInformedWorkComplete),

            powerOffDirectorFlammableProductSignature: electricFenceChecklist.powerOffDirectorFlammableProductSignature,
            powerOffExternalDirectorFlammableProductSignature:
                electricFenceChecklist.powerOffExternalDirectorFlammableProductSignature,
            powerOffResponsibleElectricianSignature: electricFenceChecklist.powerOffResponsibleElectricianSignature,
            powerOffWorkLeaderSignature: electricFenceChecklist.powerOffWorkLeaderSignature,
            powerOnDirectorFlammableProductSignature: electricFenceChecklist.powerOnDirectorFlammableProductSignature,
            powerOnExternalDirectorFlammableProductSignature:
                electricFenceChecklist.powerOnExternalDirectorFlammableProductSignature,
            powerOnResponsibleElectricianSignature: electricFenceChecklist.powerOnResponsibleElectricianSignature,
            powerOnWorkLeaderSignature: electricFenceChecklist.powerOnWorkLeaderSignature
        },
        electricFenceOnOff: formElement(measures.electricFenceOnOff),
        fireGuardsPerTeamChecked: formElement(measures.fireGuardsPerTeamChecked),
        gasFreeDeclaration: formElement(measures.gasFreeDeclaration),
        guardsPerTeamChecked: formElement(measures.guardsPerTeamChecked),
        guardType: formElement(measures.guardType),
        interventionOnProcessEquipment: formElement(measures.interventionOnProcessEquipment),
        isFlangeOpeningIncludedInPrint: formElement(measures.isFlangeOpeningIncludedInPrint),
        lineGuardWillBeInformed: formElement(measures.lineGuardWillBeInformed),
        numberOfFireGuardsPerTeam: formElement(measures.numberOfFireGuardsPerTeam),
        numberOfGuardsPerTeam: formElement(measures.numberOfGuardsPerTeam),
        otherInformation: formElement(measures.otherInformation),
        processEquipmentCleanedAndPressureFree: formElement(measures.processEquipmentCleanedAndPressureFree),
        take2: formElement(measures.take2),
        take2Checklist: {
            dutySwitchIsDisconnected: formElement(take2Checklist.dutySwitchIsDisconnected),
            equipmentIsDrainedAndNoPreassure: formElement(take2Checklist.equipmentIsDrainedAndNoPreassure),
            hasAppropriateScaffolding: formElement(take2Checklist.hasAppropriateScaffolding),
            haveEquipment: formElement(take2Checklist.haveEquipment),
            haveProtectionEquipment: formElement(take2Checklist.haveProtectionEquipment),
            haveReadPermitAndTerms: formElement(take2Checklist.haveReadPermitAndTerms),
            haveUnderstoodInstructions: formElement(take2Checklist.haveUnderstoodInstructions),
            isNearbyWork: formElement(take2Checklist.isNearbyWork),
            needsBlockingOff: formElement(take2Checklist.needsBlockingOff),
            rightPlaceAndEquipment: formElement(take2Checklist.rightPlaceAndEquipment),
            riskObservationCauseDescription: formElement(take2Checklist.riskObservationCauseDescription),
            riskObservationCourseOfEvents: formElement(take2Checklist.riskObservationCourseOfEvents),
            riskObservationDateTime: formElement(take2Checklist.riskObservationDateTime),
            riskObservationFixSuggestion: formElement(take2Checklist.riskObservationFixSuggestion),
            riskObservationLocation: formElement(take2Checklist.riskObservationLocation),
            riskObservationNotifier: formElement(take2Checklist.riskObservationNotifier),
            riskOfBurnsCrushCuts: formElement(take2Checklist.riskOfBurnsCrushCuts),
            riskOfFallsOrFallingObjects: formElement(take2Checklist.riskOfFallsOrFallingObjects),
            riskOfFire: formElement(take2Checklist.riskOfFire),
            whatRTO: formElement(take2Checklist.whatRTO),
            whereIsClosestAlarmEquipmentDescription: formElement(
                take2Checklist.whereIsClosestAlarmEquipmentDescription
            ),
            whereIsClosestEyeWashAndShowerDescription: formElement(
                take2Checklist.whereIsClosestEyeWashAndShowerDescription
            ),
            whichProcessEquipmentMediaDescription: formElement(take2Checklist.whichProcessEquipmentMediaDescription),
            whereIsClosestExtinguishingEquipmentDescription: formElement(
                take2Checklist.whereIsClosestExtinguishingEquipmentDescription
            ),
            hasFireRisk: formElement(take2Checklist.hasFireRisk),
            haveKnowledgeOfProcessEquipmentMedia: formElement(take2Checklist.haveKnowledgeOfProcessEquipmentMedia),
            knowWhereClosestAlarmEquipmentIs: formElement(take2Checklist.knowWhereClosestAlarmEquipmentIs),
            knowWhereClosestExtinguishingEquipmentIs: formElement(take2Checklist.knowWhereClosestExtinguishingEquipmentIs),
            knowWhereClosestEyeWashAndShowerIs: formElement(take2Checklist.knowWhereClosestEyeWashAndShowerIs),
            needsWorkplaceBlockingOff: formElement(take2Checklist.needsWorkplaceBlockingOff)
        },
        workOnRoad: formElement(measures.workOnRoad),
        workOnRoadChecklist: {
            hasTAPlan: formElement(workOnRoadChecklist.hasTAPlan),
            hasAtLeastTwoTrafficSignBoards: formElement(workOnRoadChecklist.hasAtLeastTwoTrafficSignBoards),
            allWorkersHaveCorrectRoadWorkTraining: formElement(workOnRoadChecklist.allWorkersHaveCorrectRoadWorkTraining),
            allWorkersHaveCorrectProtectiveEquipment: formElement(workOnRoadChecklist.allWorkersHaveCorrectProtectiveEquipment),
            canUnprotectedIndividualsPassSafely: formElement(workOnRoadChecklist.canUnprotectedIndividualsPassSafely)
        },
        constructionPower: formElement(measures.constructionPower),
        constructionPowerChecklist: {
            willCableBePlacedOnBareGround: formElement(constructionPowerChecklist.willCableBePlacedOnBareGround),
            allJunctionsInTrayOrSuspendedAboveGround: formElement(constructionPowerChecklist.allJunctionsInTrayOrSuspendedAboveGround),
            cablesAreWithoutTripHazard: formElement(constructionPowerChecklist.cablesAreWithoutTripHazard),
            cableIsInProtectionTube: formElement(constructionPowerChecklist.cableIsInProtectionTube),
            cableGoesOverRoadCycleOrWalkway: formElement(constructionPowerChecklist.cableGoesOverRoadCycleOrWalkway),
            isCableProtectedWithRunOverProtection: formElement(constructionPowerChecklist.isCableProtectedWithRunOverProtection),
            haveSignsWarningForCableOverRoad: formElement(constructionPowerChecklist.haveSignsWarningForCableOverRoad)
        }
    };
}

